<template>
  <UserIdleGuard @locked="idleLocked=$event" />
  <div v-if="idleLocked" class="idle-placeholder" aria-hidden="true"><div></div><section><div></div><div></div><div></div></section></div>
  <div v-else>
  <Navbar />
  <div class="user-layout__content"><router-view :key="$route.fullPath" /></div>
  <FooterMenu v-if="userAgentDetails.screenType === 'small'" />
  <Footer />
  </div>
</template>
  
  <script>
import UserIdleGuard from "@/components/UserIdleGuard.vue";
import Navbar from "@/components/user/Navbar.vue";
import Footer from "@/components/user/Footer.vue";
import FooterMenu from "@/components/user/FooterMenu.vue";

export default {
  components: { UserIdleGuard, Navbar, Footer, FooterMenu },
  data() {
    return {
      idleLocked:true,
      userAgentDetails: {},
    };
  },

  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    handleUserAgentDetails() {
      this.userAgentDetails = this.$root.getUserAgentDetails();
    },
  },

  created() {
    window.addEventListener("resize", this.handleUserAgentDetails);
    this.handleUserAgentDetails();
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleUserAgentDetails);
  },

  mounted() {
    this.userAgentDetails = this.$root.getUserAgentDetails();
    this.checkMounted = true;
  },
};
</script>
  
  <style lang="scss" scoped>
  @media (max-width: 768px) {
    .user-layout__content {
      padding-bottom: calc(112px + env(safe-area-inset-bottom, 0px));
    }
  }
  </style>

<style scoped>.idle-placeholder{min-height:90vh;padding:40px;filter:blur(10px);pointer-events:none}.idle-placeholder>div{height:70px;background:#25262d;border-radius:20px}.idle-placeholder section{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:40px}.idle-placeholder section div{height:360px;background:#25262d;border-radius:20px}@media(max-width:700px){.idle-placeholder{padding:20px}.idle-placeholder section{grid-template-columns:1fr}.idle-placeholder section div{height:180px}}</style>
